<template>
	<div id="app" ref="app">
		<title-bar v-if="$route.meta.showNavbar"></title-bar>
		<loading v-if="$route.meta.showNavbar && isLoading" />
		<router-view />
	</div>
</template>

<script>
import TitleBar from "./components/common/TitleBar.vue";
import Loading from './components/common/Loading.vue';
export default {
	name: 'App',
	components: {
		TitleBar,
		Loading,
	},
	created() {
		
	},
	computed: {
		isLoading() {
			return this.$permissionStore.state.isLoading;
		},
	},
	mounted() {

	},

};
</script>

<style>
@import 'assets/scss/style.scss';

html,
body {
	width: 100%;
	/* height: 100%; */
	box-sizing: border-box;
	padding: 0px;
	margin: 0px;
	background-color: rgb(242, 242, 247) !important;
	letter-spacing: 1px;
	padding-right: 0 !important
}

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	width: 100%;
	height: 100%;
}

section {
	height: 100%;
}

.el-input.is-disabled .el-input__inner {
	color: #030304;
	/* font-style: oblique; */
}

.el-dialog {
	background-color: #ffffff !important;
	border: 1px solid rgb(223, 223, 223);
}

.el-dialog__header {
	background: #f4f4f4;
	padding: 10px;
}

.user-search {
	background: #ffffff;
	border: 1px solid #eeeeee;
	border-radius: 10px;
	margin-top: 15px;
	margin-bottom: 10px;
	padding: 0 15px;
}

.el-dialog__title {
	font-size: 18px;
	font-weight: 600;
	color: #000000;
}

.el-dialog__close {
	background-color: transparent;
}

.el-dialog__headerbtn .el-dialog__close {
	color: #000000;
}

.el-dialog__headerbtn:hover .el-dialog__close {
	color: #000000;
}

.el-message--info {
	background: #fcf8e3;
}

.el-message--info .el-message__content {
	color: #000000;
}

.el-button>span {
	margin-left: 5px;
}

.el-dialog__headerbtn {
	top: 14px;
	font-size: 18px;
}

.el-dialog__body {
	background-color: #ffffff;
	padding-bottom: 5px !important;
}

.el-dialog__footer {
	background-color: #ffffff;
}

.el-input__inner {
	border: 1px solid #cfcfcf;
}

.el-input__inner:hover {
	border: 1px solid #86aaff;
}

.el-form-item {
	margin-bottom: 7px;
	margin-top: 7px;
}


.el-form-item__error {
	padding-top: 0px;
}

.el-tooltip__popper {
	max-width: 800px;
}

.el-button--mini {
	padding: 7px 10px;
}

.pd20 {
	padding: 0 20px;
	height: calc(100vh - 130px);
	background: rgb(242, 242, 247);
	overflow-y: auto;
}

.pagination {
	text-align: right;
}

.drawer-footer {
	position: fixed;
	bottom: 0px;
	right: 0px;
	width: 600px;
	height: 50px;
	background: #e6e6e6;
	display: flex;
	align-items: center;
	border-top: 1px solid #d0d0d0;
	padding-left: 20px;
}

.el-drawer__header {
	margin-bottom: 15px;
	padding: 15px 15px;
	border-bottom: 1px solid #eeeeee;
}

/* 弹出框分割线 --目前只包含底部线 */
.dialog-footer {
	border-top: 1px solid #d0d0d0;
	padding: 20px 0 0px 0;
	display: flex;
	justify-content: flex-end;
}

.fontWeight600 {
	font-weight: 600;
}

.router-tab__item {
	width: 100px;
	justify-content: center;
	color: #2c2c2c !important;
	margin-top: 5px;
	font-size: 12px !important;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	background: #cfcfd5;
	color: #ffffff !important;
}

.router-tab__item.is-active {
	width: 100px !important;
	justify-content: center;
	background: #ffffff;
	color: #2c2c2c !important;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	margin-top: 5px;
	font-size: 12px;
}

.router-tab__container {
	background: rgb(242, 242, 247) !important;
}

.router-tab__item:hover.is-closable {
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	background: #919194;
}

/* 列表主体的高度 */
.table-minheight {
	height: calc(100vh - 258px);
	overflow-y: auto;
	background: #ffffff !important;
	border-radius: 10px;
}

.radius-10 {
	border-radius: 10px;
}

/* 面包屑默认样式 */
.el-breadcrumb__inner {
	color: #cccccc;
}

.el-form--label-top .el-form-item__label {
	padding: 0px 0px;
}


.el-popover {
	max-width: 400px;
	/* 限制宽度 */
	max-height: 400px;
	/* 限制高度 */
	overflow: auto;
	/* 当内容超出时显示滚动条 */
	margin-left: 10px;
}

.el-input-number .el-input__inner {
	text-align: left;
}

.el-message {
	z-index: 99999999 !important;
}

.add_bg {
	width: 800px;
	margin: 0 auto;
}

.input_200px {
	width: 400px !important;
}

.input_dialog {
	width: 1000px !important;
}

.select_200px {
	width: 200px !important;
}

.margin_top_40 {
	margin-top: 3.5rem;
}

.margin_bottom_40 {
	margin-bottom: 0px;
}

.add_bg_800px {
	width: 800px;
	margin: 0 auto;
}

.state_box {
	background: #5ce27f;
	color: #ffffff;
	width: 70px;
	height: 24px;
	border-radius: 3px;
	padding: 0 8px;
	box-sizing: border-box;
	display: inline-block;
	line-height: 24px;
	text-align-last: justify
}

.separate_div {
	width: 100%;
	height: 10px;
	background: rgb(242, 242, 247);
}

.line_div {
	width: 100%;
	height: 1px;
	background: rgb(242, 242, 247);
}

.el-drawer {
	width: 600px !important;
}

  </style>